import { makeAutoObservable, runInAction } from 'mobx';

export class AppStore {
  alert = null;

  constructor() {
    makeAutoObservable(this);
  }

  setAlert = (message, status, callbackFn = undefined) => {
    runInAction(
      () =>
        (this.alert = {
          message,
          status,
          onConfirm: callbackFn,
        }),
    );
  };

  removeAlert = () => {
    runInAction(() => (this.alert = null));
  };
}

export const appStore = new AppStore();
